import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import styled from "styled-components";
import { Translate, I18n } from "react-redux-i18n";
import Utilities from "../../Helpers/Utilities";
import { getXsrfToken } from "../../Store/Security/Actions";
import { editUserInfo } from "../../Store/Account/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";

// region Style
const Button = styled.button`
    width: 100%;
`;
// endregion

class CustomerInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receivedSuccessfulResponse: false
        };
    }

    componentDidMount() {
        const { change, userInfo } =this.props;

        change("CompanyName", userInfo.companyName);
        change("FirstName", userInfo.firstName);
        change("LastName", userInfo.lastName);
        change("Email", userInfo.email);
        change("Phone", userInfo.phone);
    }

    renderTextField(field) {
        const { meta: { touched, error }, size, label, type, input } = field;
        const className = `col-md-${size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <label><Translate value={label} />:</label>
                <input type={type} {...input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderTextFieldReadOnly(field) {
        const { meta: { touched, error }, size, label, type, input } = field;
        const className = `col-md-${size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <label><Translate value={label} />:</label>
                <input readOnly type={type} {...input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderErrors() {
        if (this.props.userInfoStatus.response) {
            const { response: { data } } = this.props.userInfoStatus;
            if (data) {
                this.props.toggleBlockingStatus(false);

                return (
                    <div className="col-md-12">
                        <div className="alert bg--error" style={{ marginBottom: 0 }}>
                            <div className="alert__body">
                                <span>{data}</span>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    onSubmit(values) {
        const { getXsrfToken, editUserInfo } = this.props;

        getXsrfToken(({ token }) => {
            const obj = {
                ...values,
                FirstName: Utilities.toTitleCase(values.FirstName).trim(),
                LastName: Utilities.toTitleCase(values.LastName).trim(),
                CompanyName: Utilities.toTitleCase(values.CompanyName).trim(),
                Phone: values.Phone,
                __RequestVerificationToken: token
            };

            editUserInfo(obj, () => {
                this.setState({ receivedSuccessfulResponse: true });
            });
        });
    }

    render() {
        const { userInfo, handleSubmit, submitting } = this.props;
        const { receivedSuccessfulResponse } = this.state;

        return (
            <div id="account-profile" className="account-tab">
                <h4><Translate value="profile.info.title" /></h4>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <div className="row">
                        <Field
                            name="CompanyName"
                            type="text"
                            label="account.company"
                            size="12"
                            component={this.renderTextField}
                        />
                        <Field
                            name="FirstName"
                            type="text"
                            label="account.firstName"
                            size="6"
                            component={this.renderTextField}
                        />
                        <Field
                            name="LastName"
                            type="text"
                            label="account.lastName"
                            size="6"
                            component={this.renderTextField}
                        />
                        <Field
                            name="Email"
                            type="email"
                            label="account.email"
                            size="6"
                            component={this.renderTextFieldReadOnly}
                        />
                        <Field
                            name="Phone"
                            type="text"
                            label="account.phoneNumber"
                            size="6"
                            normalize={Utilities.normalizePhone}
                            component={this.renderTextField}
                        />
                        {/* <div className="col-md-12">
                            <label><Translate value="account.station" />:</label>
                            <input type="text" name="Station" defaultValue={userInfo.station} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label><Translate value="account.contractNumber" />:</label>
                            <input type="text" name="ContractNumber" defaultValue={userInfo.contractNumber} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label><Translate value="account.employeeId" />:</label>
                            <input type="text" name="EmployeeId" defaultValue={userInfo.employeeId} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label><Translate value="account.purchaseEligibilityDate" />:</label>
                            <input type="text" name="PurchaseEligibilityDate" defaultValue={I18n.l(userInfo.purchaseEligibilityDate, { dateFormat: "locale.date.short" })} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label><Translate value="account.onTheRoadEligibilityDate" />:</label>
                            <input type="text" name="OnTheRoadEligibilityDate" defaultValue={I18n.l(userInfo.onTheRoadEligibilityDate, { dateFormat: "locale.date.short" })} readOnly />
                        </div>*/}
                    </div>
                    <div className="row">
                        {this.renderErrors()}
                        <div className="col-lg-4">
                            <button type="submit" className="btn btn--primary type--uppercase" disabled={submitting}><Translate value="profile.info.save" /></button>
                        </div>
                    </div>
                    {receivedSuccessfulResponse &&
                        <div className="row">
                            <div className="col-lg-4">
                                <label><Translate value="profile.info.success" /></label>
                            </div>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

CustomerInfo.propTypes = {
    handleSubmit: PropTypes.func,
    getXsrfToken: PropTypes.func,
    change: PropTypes.func,
    editUserInfo: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    submitting: PropTypes.bool,
    i18n: PropTypes.object,
    config: PropTypes.object,
    userInfo: PropTypes.object,
    userInfoStatus: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        userInfo: state.userInfo,
        userInfoStatus: state.userInfoStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken,
        editUserInfo,
        toggleBlockingStatus
    }, dispatch);
}

function validate(values) {
    const errors = {};

    if (!values.CompanyName) {
        errors.CompanyName = I18n.t("validation.account.company.required");
    }
    if (!values.FirstName) {
        errors.FirstName = I18n.t("validation.account.firstName.required");
    }
    if (!values.LastName) {
        errors.LastName = I18n.t("validation.account.lastName.required");
    }
    if (!values.Email) {
        errors.Email = I18n.t("validation.account.email.required");
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.Email)) {
        errors.Email = I18n.t("validation.account.email.email");
    }

    if (!values.Phone) {
        errors.Phone = I18n.t("validation.account.phone.required");
    } else if (!/^\(?\d{3}\)?[ ]?\d{3}[- ]?\d{4}$/i.test(values.Phone)) {
        errors.Phone = I18n.t("validation.account.phone.number");
    }

    return errors;
}

export default reduxForm({
    validate,
    form: "EditUserInfo"
})(
    connect(mapStateToProps, mapDispatchToProps)(CustomerInfo)
);